module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-ni.6b1e606c.png";